export default "__VITE_ASSET__DdQ66B5R__"